"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartPopover = exports.renderCartButton = exports.getShoppingCartColors = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_modal_1 = require("@ryerson/frontend.modal");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("./StyledComponents");

var frontend_application_2 = require("@ryerson/frontend.application");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var util_1 = require("../common/util");

var frontend_theme_2 = require("@ryerson/frontend.theme");

var getShoppingCartColors = function getShoppingCartColors(theme, themeName) {
  return {
    background: themeName === frontend_theme_1.ThemeNames.southernToolSteel ? theme.colors.primary.primaryBrand : theme.colors.primary.accentBrand,
    content: themeName === frontend_theme_1.ThemeNames.southernToolSteel ? theme.colors.primary.white : theme.colors.primary.secondaryBrand
  };
};

exports.getShoppingCartColors = getShoppingCartColors;

var renderCartButton = function renderCartButton(theme, themeName, mobileBreakPoint, language, storeDirectory, shoppingCart) {
  var _a;

  var shoppingCartColors = (0, exports.getShoppingCartColors)(theme, themeName);
  var totalItemsInCart = ((_a = shoppingCart === null || shoppingCart === void 0 ? void 0 : shoppingCart.items) === null || _a === void 0 ? void 0 : _a.length) || 0;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    style: (0, StyledComponents_1.cartButton)(shoppingCartColors.background),
    onClick: function onClick() {
      (0, util_1.navigateLink)(storeDirectory, "/cart");
    },
    className: "header-cart-button",
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      justifyContent: "space-evenly",
      alignItems: "center",
      style: (0, StyledComponents_1.cartButton)(shoppingCartColors.background),
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: totalItemsInCart > 0 ? (0, jsx_runtime_1.jsx)(frontend_notification_1.Badge, {
          type: "primary",
          size: "md",
          badgeContent: totalItemsInCart.toString(),
          badgeType: "notification",
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "shopping-cart",
            size: "sm",
            color: shoppingCartColors.content,
            css: (0, StyledComponents_1.shoppingCartStyle)(mobileBreakPoint),
            onClick: function onClick() {
              (0, util_1.navigateLink)(storeDirectory, "/cart");
            },
            dataTestId: "header-shopping-cart-button"
          })
        }) : (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "shopping-cart",
          size: "sm",
          color: shoppingCartColors.content,
          css: (0, StyledComponents_1.shoppingCartStyle)(mobileBreakPoint),
          onClick: function onClick() {
            (0, util_1.navigateLink)(storeDirectory, "/cart");
          },
          dataTestId: "header-shopping-cart-button"
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          breakPoint: mobileBreakPoint,
          size: "sm",
          color: shoppingCartColors.content,
          children: frontend_common_1.withTranslation.cart[language]
        })
      })]
    })
  });
};

exports.renderCartButton = renderCartButton;

var CartPopover = function CartPopover(_ref) {
  var mobileBreakPoint = _ref.mobileBreakPoint,
      setIsCartExpanded = _ref.setIsCartExpanded,
      isCartExpanded = _ref.isCartExpanded,
      notifications = _ref.notifications,
      storeDirectory = _ref.storeDirectory,
      shoppingCart = _ref.shoppingCart;

  var _a;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      language = _ref2.localization.language;

  var _ref3 = (0, frontend_theme_2.useTheme)(),
      theme = _ref3.theme,
      themeName = _ref3.themeName; // This is used to pass to forward ref in order to expose the popper instance and its methods


  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var popperRef = react_1.default.useRef(null);
  react_1.default.useEffect(function () {
    var _a, _b;

    if (hasMounted) {
      if (isCartExpanded) {
        (_a = popperRef === null || popperRef === void 0 ? void 0 : popperRef.current) === null || _a === void 0 ? void 0 : _a.open();
      } else {
        (_b = popperRef === null || popperRef === void 0 ? void 0 : popperRef.current) === null || _b === void 0 ? void 0 : _b.close();
      }
    }
  }, [isCartExpanded]);
  react_1.default.useEffect(function () {
    setHasMounted(true); //cleanup function

    return function () {
      var _a;

      setHasMounted(false);
      (_a = popperRef === null || popperRef === void 0 ? void 0 : popperRef.current) === null || _a === void 0 ? void 0 : _a.close();
    };
  }, []);
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    children: (0, jsx_runtime_1.jsx)(frontend_modal_1.Popover, {
      disabled: true,
      alignment: "bottom-end",
      caretColor: theme.colors.primary.lighterGray,
      ref: popperRef,
      offset: [0, 10],
      trigger: (0, exports.renderCartButton)(theme, themeName, mobileBreakPoint, language, storeDirectory, shoppingCart),
      onClose: function onClose() {
        return setIsCartExpanded(false);
      },
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        className: "global-menus",
        justifyContent: "space-between",
        style: (0, StyledComponents_1.globalCartNotificationStyles)(),
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (_a = notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (message) {
            return message.type === frontend_application_2.NotificationsType.AddToCart;
          }).pop()) === null || _a === void 0 ? void 0 : _a.message
        })
      })
    })
  });
};

exports.CartPopover = CartPopover;